export default __webpack_public_path__ + "static/media/bnr3.ea89a71c.jpg";